export enum OrganizationFlags {
    ADMIN_CLIENT = 1,
    TOP_LEVEL = 2,
    PUBLISHER = 4,
    VAULT_ENABLED = 8,
    HAS_CHILDREN = 16,
    HAS_SHARED = 32,
    PUBLISHER_AUDIO = 64,
    PUBLISHER_VIDEO = 128
};

export enum License {
    SPOT_AUDIO = 'SPOT.AUDIO',
    SPOT_SCENT = 'SPOT.SCENT',
    SPOT_VIDEO = 'SPOT.VIDEO'
};